// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignsGlobalRateLimitsAppGroupIdResult = arrayOf(
  objectOf({
    channel: string,
    limit: number,
  })
);
